import React from "react";

/**
 * Card wrapper for a chart section, with a title and up to two filter <select>s.
 *
 * @param {string} title
 * @param {{label: string, options: string[], value?: string, onChange?: (v:string)=>void}[]} [filters]
 * @param {React.ReactNode} children - The chart itself (e.g. a <img>, or a recharts component)
 */
export default function ChartCard({ title, filters = [], children }) {
  return (
    <div className="bg-white rounded-xl border border-surface-200 p-5 shadow-sm flex flex-col min-h-[300px] transition-all duration-200 hover:shadow-md">
      <div className="flex justify-between items-center mb-5 flex-wrap gap-3">
        <h2 className="text-base font-semibold text-surface-800">{title}</h2>
        {filters.length > 0 && (
          <div className="flex gap-2">
            {filters.map((filter, i) => (
              <select
                key={i}
                value={filter.value}
                onChange={(e) => filter.onChange?.(e.target.value)}
                className="rounded-lg border border-surface-200 bg-surface-50 py-1.5 pl-3 pr-8 text-sm text-surface-700 font-medium focus:ring-2 focus:ring-primary-400/20 focus:border-primary-400 focus:outline-none transition-all duration-200 cursor-pointer"
              >
                {filter.options.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            ))}
          </div>
        )}
      </div>
      <div className="flex-1 w-full flex items-center justify-center">{children}</div>
    </div>
  );
}